/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserProfile = /* GraphQL */ `
  mutation CreateUserProfile(
    $input: CreateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    createUserProfile(input: $input, condition: $condition) {
      id
      username
      displayName
      bio
      avatarUrl
      createdAt
      updatedAt
    }
  }
`;

export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile(
    $input: UpdateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    updateUserProfile(input: $input, condition: $condition) {
      id
      username
      displayName
      bio
      avatarUrl
      createdAt
      updatedAt
    }
  }
`;

export const deleteUserProfile = /* GraphQL */ `
  mutation DeleteUserProfile(
    $input: DeleteUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    deleteUserProfile(input: $input, condition: $condition) {
      id
      username
      displayName
      bio
      avatarUrl
      createdAt
      updatedAt
    }
  }
`;

export const createCustomCharacter = /* GraphQL */ `
  mutation CreateCustomCharacter($input: CreateCharacterInput!) {
    createCustomCharacter(input: $input) {
      id
      name
      characterClass
      race
      level
      experience
      maxHealth
      currentHealth
      gold
      strength
      dexterity
      constitution
      intelligence
      wisdom
      charisma
      armorClass
      speed
      initiative
      proficiencyBonus
      alignment
      backstory
      notes
      owner
      items {
        nextToken
        __typename
      }
      skills {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      campaignProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCustomCharacter = /* GraphQL */ `
  mutation UpdateCustomCharacter($input: UpdateCharacterInput!) {
    updateCustomCharacter(input: $input) {
      id
      name
      characterClass
      race
      level
      experience
      maxHealth
      currentHealth
      gold
      strength
      dexterity
      constitution
      intelligence
      wisdom
      charisma
      armorClass
      speed
      initiative
      proficiencyBonus
      alignment
      backstory
      notes
      owner
      items {
        nextToken
        __typename
      }
      skills {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      campaignProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCustomCharacter = /* GraphQL */ `
  mutation DeleteCustomCharacter($input: DeleteCharacterInput!) {
    deleteCustomCharacter(input: $input) {
      id
      name
      characterClass
      race
      level
      experience
      maxHealth
      currentHealth
      gold
      strength
      dexterity
      constitution
      intelligence
      wisdom
      charisma
      armorClass
      speed
      initiative
      proficiencyBonus
      alignment
      backstory
      notes
      owner
      items {
        nextToken
        __typename
      }
      skills {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      campaignProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const sendFriendRequest = /* GraphQL */ `
  mutation SendFriendRequest($input: SendFriendRequestInput!) {
    sendFriendRequest(input: $input) {
      id
      senderId
      receiverId
      status
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const respondToFriendRequest = /* GraphQL */ `
  mutation RespondToFriendRequest($input: RespondToFriendRequestInput!) {
    respondToFriendRequest(input: $input) {
      id
      senderId
      receiverId
      status
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createCharacter = /* GraphQL */ `
  mutation CreateCharacter(
    $input: CreateCharacterInput!
    $condition: ModelCharacterConditionInput
  ) {
    createCharacter(input: $input, condition: $condition) {
      id
      name
      characterClass
      race
      level
      experience
      maxHealth
      currentHealth
      gold
      strength
      dexterity
      constitution
      intelligence
      wisdom
      charisma
      armorClass
      speed
      initiative
      proficiencyBonus
      alignment
      backstory
      notes
      owner
      items {
        nextToken
        __typename
      }
      skills {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      campaignProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCharacter = /* GraphQL */ `
  mutation UpdateCharacter(
    $input: UpdateCharacterInput!
    $condition: ModelCharacterConditionInput
  ) {
    updateCharacter(input: $input, condition: $condition) {
      id
      name
      characterClass
      race
      level
      experience
      maxHealth
      currentHealth
      gold
      strength
      dexterity
      constitution
      intelligence
      wisdom
      charisma
      armorClass
      speed
      initiative
      proficiencyBonus
      alignment
      backstory
      notes
      owner
      items {
        nextToken
        __typename
      }
      skills {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      campaignProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCharacter = /* GraphQL */ `
  mutation DeleteCharacter(
    $input: DeleteCharacterInput!
    $condition: ModelCharacterConditionInput
  ) {
    deleteCharacter(input: $input, condition: $condition) {
      id
      name
      characterClass
      race
      level
      experience
      maxHealth
      currentHealth
      gold
      strength
      dexterity
      constitution
      intelligence
      wisdom
      charisma
      armorClass
      speed
      initiative
      proficiencyBonus
      alignment
      backstory
      notes
      owner
      items {
        nextToken
        __typename
      }
      skills {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      campaignProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBlogPost = /* GraphQL */ `
  mutation CreateBlogPost(
    $input: CreateBlogPostInput!
    $condition: ModelBlogPostConditionInput
  ) {
    createBlogPost(input: $input, condition: $condition) {
      id
      title
      content
      excerpt
      author
      publishDate
      svgContent
      iconName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBlogPost = /* GraphQL */ `
  mutation UpdateBlogPost(
    $input: UpdateBlogPostInput!
    $condition: ModelBlogPostConditionInput
  ) {
    updateBlogPost(input: $input, condition: $condition) {
      id
      title
      content
      excerpt
      author
      publishDate
      svgContent
      iconName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBlogPost = /* GraphQL */ `
  mutation DeleteBlogPost(
    $input: DeleteBlogPostInput!
    $condition: ModelBlogPostConditionInput
  ) {
    deleteBlogPost(input: $input, condition: $condition) {
      id
      title
      content
      excerpt
      author
      publishDate
      svgContent
      iconName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBadge = /* GraphQL */ `
  mutation CreateBadge(
    $input: CreateBadgeInput!
    $condition: ModelBadgeConditionInput
  ) {
    createBadge(input: $input, condition: $condition) {
      id
      name
      description
      imageUrl
      achievements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateBadge = /* GraphQL */ `
  mutation UpdateBadge(
    $input: UpdateBadgeInput!
    $condition: ModelBadgeConditionInput
  ) {
    updateBadge(input: $input, condition: $condition) {
      id
      name
      description
      imageUrl
      achievements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteBadge = /* GraphQL */ `
  mutation DeleteBadge(
    $input: DeleteBadgeInput!
    $condition: ModelBadgeConditionInput
  ) {
    deleteBadge(input: $input, condition: $condition) {
      id
      name
      description
      imageUrl
      achievements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createAchievement = /* GraphQL */ `
  mutation CreateAchievement(
    $input: CreateAchievementInput!
    $condition: ModelAchievementConditionInput
  ) {
    createAchievement(input: $input, condition: $condition) {
      id
      name
      description
      rewardXP
      rewardGold
      rewardBadge {
        id
        name
        description
        imageUrl
        createdAt
        updatedAt
        owner
        __typename
      }
      characterAchievements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      badgeAchievementsId
      owner
      __typename
    }
  }
`;
export const updateAchievement = /* GraphQL */ `
  mutation UpdateAchievement(
    $input: UpdateAchievementInput!
    $condition: ModelAchievementConditionInput
  ) {
    updateAchievement(input: $input, condition: $condition) {
      id
      name
      description
      rewardXP
      rewardGold
      rewardBadge {
        id
        name
        description
        imageUrl
        createdAt
        updatedAt
        owner
        __typename
      }
      characterAchievements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      badgeAchievementsId
      owner
      __typename
    }
  }
`;
export const deleteAchievement = /* GraphQL */ `
  mutation DeleteAchievement(
    $input: DeleteAchievementInput!
    $condition: ModelAchievementConditionInput
  ) {
    deleteAchievement(input: $input, condition: $condition) {
      id
      name
      description
      rewardXP
      rewardGold
      rewardBadge {
        id
        name
        description
        imageUrl
        createdAt
        updatedAt
        owner
        __typename
      }
      characterAchievements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      badgeAchievementsId
      owner
      __typename
    }
  }
`;
export const createCharacterAchievement = /* GraphQL */ `
  mutation CreateCharacterAchievement(
    $input: CreateCharacterAchievementInput!
    $condition: ModelCharacterAchievementConditionInput
  ) {
    createCharacterAchievement(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      achievement {
        id
        name
        description
        rewardXP
        rewardGold
        createdAt
        updatedAt
        badgeAchievementsId
        owner
        __typename
      }
      achievementId
      dateUnlocked
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateCharacterAchievement = /* GraphQL */ `
  mutation UpdateCharacterAchievement(
    $input: UpdateCharacterAchievementInput!
    $condition: ModelCharacterAchievementConditionInput
  ) {
    updateCharacterAchievement(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      achievement {
        id
        name
        description
        rewardXP
        rewardGold
        createdAt
        updatedAt
        badgeAchievementsId
        owner
        __typename
      }
      achievementId
      dateUnlocked
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteCharacterAchievement = /* GraphQL */ `
  mutation DeleteCharacterAchievement(
    $input: DeleteCharacterAchievementInput!
    $condition: ModelCharacterAchievementConditionInput
  ) {
    deleteCharacterAchievement(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      achievement {
        id
        name
        description
        rewardXP
        rewardGold
        createdAt
        updatedAt
        badgeAchievementsId
        owner
        __typename
      }
      achievementId
      dateUnlocked
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createCampaign = /* GraphQL */ `
  mutation CreateCampaign(
    $input: CreateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    createCampaign(input: $input, condition: $condition) {
      id
      name
      description
      startDate
      endDate
      characterProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateCampaign = /* GraphQL */ `
  mutation UpdateCampaign(
    $input: UpdateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    updateCampaign(input: $input, condition: $condition) {
      id
      name
      description
      startDate
      endDate
      characterProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteCampaign = /* GraphQL */ `
  mutation DeleteCampaign(
    $input: DeleteCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    deleteCampaign(input: $input, condition: $condition) {
      id
      name
      description
      startDate
      endDate
      characterProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createCharacterCampaignProgress = /* GraphQL */ `
  mutation CreateCharacterCampaignProgress(
    $input: CreateCharacterCampaignProgressInput!
    $condition: ModelCharacterCampaignProgressConditionInput
  ) {
    createCharacterCampaignProgress(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      campaign {
        id
        name
        description
        startDate
        endDate
        createdAt
        updatedAt
        owner
        __typename
      }
      campaignId
      currentChapter
      completedQuests
      notes
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateCharacterCampaignProgress = /* GraphQL */ `
  mutation UpdateCharacterCampaignProgress(
    $input: UpdateCharacterCampaignProgressInput!
    $condition: ModelCharacterCampaignProgressConditionInput
  ) {
    updateCharacterCampaignProgress(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      campaign {
        id
        name
        description
        startDate
        endDate
        createdAt
        updatedAt
        owner
        __typename
      }
      campaignId
      currentChapter
      completedQuests
      notes
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteCharacterCampaignProgress = /* GraphQL */ `
  mutation DeleteCharacterCampaignProgress(
    $input: DeleteCharacterCampaignProgressInput!
    $condition: ModelCharacterCampaignProgressConditionInput
  ) {
    deleteCharacterCampaignProgress(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      campaign {
        id
        name
        description
        startDate
        endDate
        createdAt
        updatedAt
        owner
        __typename
      }
      campaignId
      currentChapter
      completedQuests
      notes
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createSkill = /* GraphQL */ `
  mutation CreateSkill(
    $input: CreateSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    createSkill(input: $input, condition: $condition) {
      id
      name
      description
      characterSkills {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateSkill = /* GraphQL */ `
  mutation UpdateSkill(
    $input: UpdateSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    updateSkill(input: $input, condition: $condition) {
      id
      name
      description
      characterSkills {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteSkill = /* GraphQL */ `
  mutation DeleteSkill(
    $input: DeleteSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    deleteSkill(input: $input, condition: $condition) {
      id
      name
      description
      characterSkills {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createCharacterSkill = /* GraphQL */ `
  mutation CreateCharacterSkill(
    $input: CreateCharacterSkillInput!
    $condition: ModelCharacterSkillConditionInput
  ) {
    createCharacterSkill(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      skill {
        id
        name
        description
        createdAt
        updatedAt
        owner
        __typename
      }
      skillId
      level
      experience
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateCharacterSkill = /* GraphQL */ `
  mutation UpdateCharacterSkill(
    $input: UpdateCharacterSkillInput!
    $condition: ModelCharacterSkillConditionInput
  ) {
    updateCharacterSkill(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      skill {
        id
        name
        description
        createdAt
        updatedAt
        owner
        __typename
      }
      skillId
      level
      experience
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteCharacterSkill = /* GraphQL */ `
  mutation DeleteCharacterSkill(
    $input: DeleteCharacterSkillInput!
    $condition: ModelCharacterSkillConditionInput
  ) {
    deleteCharacterSkill(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      skill {
        id
        name
        description
        createdAt
        updatedAt
        owner
        __typename
      }
      skillId
      level
      experience
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createItem = /* GraphQL */ `
  mutation CreateItem(
    $input: CreateItemInput!
    $condition: ModelItemConditionInput
  ) {
    createItem(input: $input, condition: $condition) {
      id
      name
      description
      type
      rarity
      value
      characterItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateItem = /* GraphQL */ `
  mutation UpdateItem(
    $input: UpdateItemInput!
    $condition: ModelItemConditionInput
  ) {
    updateItem(input: $input, condition: $condition) {
      id
      name
      description
      type
      rarity
      value
      characterItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteItem = /* GraphQL */ `
  mutation DeleteItem(
    $input: DeleteItemInput!
    $condition: ModelItemConditionInput
  ) {
    deleteItem(input: $input, condition: $condition) {
      id
      name
      description
      type
      rarity
      value
      characterItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createCharacterItem = /* GraphQL */ `
  mutation CreateCharacterItem(
    $input: CreateCharacterItemInput!
    $condition: ModelCharacterItemConditionInput
  ) {
    createCharacterItem(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      item {
        id
        name
        description
        type
        rarity
        value
        createdAt
        updatedAt
        owner
        __typename
      }
      itemId
      quantity
      isEquipped
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateCharacterItem = /* GraphQL */ `
  mutation UpdateCharacterItem(
    $input: UpdateCharacterItemInput!
    $condition: ModelCharacterItemConditionInput
  ) {
    updateCharacterItem(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      item {
        id
        name
        description
        type
        rarity
        value
        createdAt
        updatedAt
        owner
        __typename
      }
      itemId
      quantity
      isEquipped
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteCharacterItem = /* GraphQL */ `
  mutation DeleteCharacterItem(
    $input: DeleteCharacterItemInput!
    $condition: ModelCharacterItemConditionInput
  ) {
    deleteCharacterItem(input: $input, condition: $condition) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      item {
        id
        name
        description
        type
        rarity
        value
        createdAt
        updatedAt
        owner
        __typename
      }
      itemId
      quantity
      isEquipped
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createFriendRequest = /* GraphQL */ `
  mutation CreateFriendRequest(
    $input: CreateFriendRequestInput!
    $condition: ModelFriendRequestConditionInput
  ) {
    createFriendRequest(input: $input, condition: $condition) {
      id
      senderId
      receiverId
      status
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateFriendRequest = /* GraphQL */ `
  mutation UpdateFriendRequest(
    $input: UpdateFriendRequestInput!
    $condition: ModelFriendRequestConditionInput
  ) {
    updateFriendRequest(input: $input, condition: $condition) {
      id
      senderId
      receiverId
      status
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteFriendRequest = /* GraphQL */ `
  mutation DeleteFriendRequest(
    $input: DeleteFriendRequestInput!
    $condition: ModelFriendRequestConditionInput
  ) {
    deleteFriendRequest(input: $input, condition: $condition) {
      id
      senderId
      receiverId
      status
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createFriendship = /* GraphQL */ `
  mutation CreateFriendship(
    $input: CreateFriendshipInput!
    $condition: ModelFriendshipConditionInput
  ) {
    createFriendship(input: $input, condition: $condition) {
      id
      user1Id
      user2Id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateFriendship = /* GraphQL */ `
  mutation UpdateFriendship(
    $input: UpdateFriendshipInput!
    $condition: ModelFriendshipConditionInput
  ) {
    updateFriendship(input: $input, condition: $condition) {
      id
      user1Id
      user2Id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteFriendship = /* GraphQL */ `
  mutation DeleteFriendship(
    $input: DeleteFriendshipInput!
    $condition: ModelFriendshipConditionInput
  ) {
    deleteFriendship(input: $input, condition: $condition) {
      id
      user1Id
      user2Id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
